/**
 * DIOLYSH: close the cart drawer instantly when Checkout is clicked (2026-09-04)
 *
 * The COD King app intercepts the #checkout button click and opens its own
 * phone-verification modal in place of navigating straight to Shopify
 * checkout. Since there's no page navigation in that case, the theme's cart
 * drawer never receives a close signal and stays open behind the app's
 * modal (reported: sidebar cart still visible after clicking Checkout).
 *
 * Fix: close our own drawer the moment Checkout is clicked, without calling
 * preventDefault/stopPropagation, so any other script hooked to the same
 * click (COD King's own listener, or Shopify's native checkout redirect)
 * still runs completely untouched. Closes instantly (no slide-out
 * animation) since whatever comes next — the app's modal or native
 * checkout — covers the screen immediately anyway, same reasoning as
 * diolysh-cart-instant-close.js.
 */
document.addEventListener(
  'click',
  (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const checkoutButton = target.closest('#checkout, .cart__checkout-button');
    if (!checkoutButton) return;

    const drawer = document.getElementById('cart-drawer');
    if (!drawer || !drawer.hasAttribute('open')) return;

    drawer.removeAttribute('open');

    const dialog = drawer.querySelector('dialog');
    if (dialog) {
      dialog.classList.remove(
        'theme-drawer__dialog--opening',
        'theme-drawer__dialog--opening-inline-start',
        'theme-drawer__dialog--closing'
      );
      if (dialog.open) dialog.close();
    }

    drawer.dispatchEvent(new CustomEvent('theme-drawer:close', { bubbles: true }));
  },
  { capture: true }
);
